/* MoveUrge theme: product quick view, product page form, and slide-out cart.
   Uses Shopify's built-in cart, so discounts, apps, and checkout all work normally. */
(() => {
  const MU = window.MU || {};
  const R = MU.routes || { root: "/", cart: "/cart", cartAdd: "/cart/add", cartChange: "/cart/change" };
  const $ = (id) => document.getElementById(id);
  const esc = (s = "") => String(s).replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
  const sized = (src, w) => {
    if (!src) return "";
    const url = src.startsWith("//") ? `https:${src}` : src;
    return `${url}${url.includes("?") ? "&" : "?"}width=${w}`;
  };
  const money = (cents) => {
    const n = Number(cents) / 100;
    const fmt = MU.moneyFormat || "${{amount}}";
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      if (key === "amount_no_decimals") return Math.round(n).toLocaleString("en-US");
      if (key === "amount_with_comma_separator") return n.toFixed(2).replace(".", ",");
      return n.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    });
  };
  const priceHTML = (v) => `<span class="now">${money(v.price)}</span>${v.compare_at_price && v.compare_at_price > v.price ? `<span class="was">${money(v.compare_at_price)}</span>` : ""}`;
  const isWebImage = (src) => !/\.heic(\?|$)/i.test(src || "");
  const arrow = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';

  /* ---------- Panels ---------- */
  const overlay = $("overlay"), modal = $("product-modal"), drawer = $("cart");
  if (!overlay || !modal || !drawer) return;
  let lastFocus = null;
  function open(panel) {
    closeAll(false);
    lastFocus = document.activeElement;
    panel.classList.add("is-open"); panel.setAttribute("aria-hidden", "false");
    overlay.classList.add("is-open"); document.body.classList.add("lock");
    setTimeout(() => panel.querySelector("[data-close]").focus(), 50);
  }
  function closeAll(restore = true) {
    [modal, drawer].forEach((p) => { p.classList.remove("is-open"); p.setAttribute("aria-hidden", "true"); });
    overlay.classList.remove("is-open"); document.body.classList.remove("lock");
    if (restore && lastFocus) lastFocus.focus();
  }
  overlay.addEventListener("click", () => closeAll());
  [modal, drawer].forEach((p) => p.querySelector("[data-close]").addEventListener("click", () => closeAll()));
  document.addEventListener("keydown", (e) => { if (e.key === "Escape" && overlay.classList.contains("is-open")) closeAll(); });

  /* ---------- Cart ---------- */
  async function getCart() {
    const r = await fetch(`${R.cart}.js`, { headers: { Accept: "application/json" } });
    return r.json();
  }
  function updateCount(count) {
    document.querySelectorAll(".cart-count").forEach((el) => { el.textContent = count; el.classList.toggle("has-items", count > 0); });
    document.querySelectorAll("[data-open-cart]").forEach((b) => b.setAttribute("aria-label", `Open cart, ${count} item${count === 1 ? "" : "s"}`));
  }
  function renderCart(cart) {
    updateCount(cart.item_count);
    const list = $("cart-items"), foot = $("cart-foot");
    if (!cart.items.length) {
      const shopHref = MU.page === "index" ? "#shop" : `${R.root}#shop`.replace("//", "/");
      list.innerHTML = `<div class="drawer-empty"><img src="${MU.emptyCartImage || ""}" alt=""><h3>Your cart is empty</h3><p class="muted">Time to gear up.</p><a class="btn btn-secondary" href="${shopHref}" data-shop-link>Shop the gear</a></div>`;
      list.querySelector("[data-shop-link]").addEventListener("click", () => closeAll(false));
      foot.hidden = true;
      return;
    }
    foot.hidden = false;
    list.innerHTML = cart.items.map((i) => `
      <div class="line-item" data-key="${esc(i.key)}" data-qty="${i.quantity}">
        <a href="${esc(i.url)}"><img src="${esc(sized(i.image, 200))}" alt="" width="80" height="80" loading="lazy"></a>
        <div>
          <div class="t">${esc(i.product_title)}</div>
          <div class="v">${i.variant_title ? esc(i.variant_title) : ""}</div>
          <div class="qty"><button type="button" data-d="-1" aria-label="Decrease quantity">&minus;</button><span>${i.quantity}</span><button type="button" data-d="1" aria-label="Increase quantity">+</button></div>
        </div>
        <div style="text-align:right"><div class="p">${money(i.final_line_price)}</div><button type="button" class="remove" data-remove>Remove</button></div>
      </div>`).join("");
    $("cart-subtotal").textContent = money(cart.total_price);
  }
  async function changeLine(key, quantity) {
    const r = await fetch(`${R.cartChange}.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity }),
    });
    const cart = await r.json();
    if (!r.ok) throw new Error(cart.description || "Could not update cart");
    renderCart(cart);
  }
  async function addToCart(variantId, quantity) {
    const r = await fetch(`${R.cartAdd}.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: variantId, quantity }] }),
    });
    const data = await r.json();
    if (!r.ok) throw new Error(data.description || data.message || "Could not add to cart");
    renderCart(await getCart());
    open(drawer);
  }
  MU.addToCart = addToCart;

  $("cart-items").addEventListener("click", async (e) => {
    const row = e.target.closest(".line-item");
    if (!row) return;
    const qty = Number(row.dataset.qty);
    let next = null;
    const d = e.target.closest("[data-d]");
    if (d) next = Math.max(0, qty + Number(d.dataset.d));
    if (e.target.closest("[data-remove]")) next = 0;
    if (next === null) return;
    row.style.opacity = ".5";
    try { await changeLine(row.dataset.key, next); }
    catch (err) { row.style.opacity = ""; MU.toast && MU.toast(err.message); }
  });

  document.querySelectorAll("[data-open-cart]").forEach((b) => b.addEventListener("click", async (e) => {
    e.preventDefault();
    open(drawer);
    renderCart(await getCart());
  }));
  $("checkout").addEventListener("click", (e) => { e.currentTarget.textContent = "Opening checkout…"; });

  /* ---------- Quick view ---------- */
  const cache = {};
  let current = null, variant = null, qty = 1;
  const variantImage = (p, v) => (v && v.featured_image && v.featured_image.src) || (p.images || []).find(isWebImage) || "";
  function setMainImage(src) {
    $("pm-img").src = sized(src, 1000);
    document.querySelectorAll("#pm-thumbs button").forEach((b) => b.setAttribute("aria-current", String(b.dataset.src === src)));
  }
  function selectVariant(v) {
    variant = v;
    document.querySelectorAll("#pm-options [data-vid]").forEach((b) => b.setAttribute("aria-pressed", String(Number(b.dataset.vid) === v.id)));
    const name = $("pm-vname"); if (name) name.textContent = v.title;
    $("pm-price").innerHTML = priceHTML(v);
    if (v.featured_image) setMainImage(v.featured_image.src);
    const add = $("pm-add");
    add.disabled = !v.available;
    add.textContent = v.available ? "Add to Cart" : "Sold Out";
  }
  function openProduct(p) {
    current = p; qty = 1;
    $("pm-qty").textContent = qty;
    $("pm-title").textContent = p.title;
    $("pm-img").alt = p.title;
    $("pm-link").href = p.url || `${R.root}products/${p.handle}`;
    const imgs = (p.images || []).filter(isWebImage);
    $("pm-thumbs").innerHTML = imgs.length > 1 ? imgs.map((src, i) =>
      `<button type="button" data-src="${esc(src)}" aria-label="Show image ${i + 1}"><img src="${esc(sized(src, 160))}" alt="" loading="lazy"></button>`).join("") : "";
    const optName = p.options && p.options[0] ? (typeof p.options[0] === "string" ? p.options[0] : p.options[0].name) : "Option";
    $("pm-options").innerHTML = p.variants.length > 1 ? `
      <div class="option-label">${esc(optName)}<b id="pm-vname"></b></div>
      <div class="variants">${p.variants.map((v) => `<button type="button" data-vid="${v.id}" aria-pressed="false" ${v.available ? "" : "disabled"}>${esc(v.title)}</button>`).join("")}</div>` : "";
    $("pm-desc").innerHTML = p.description || "";
    setMainImage(variantImage(p, p.variants[0]));
    selectVariant(p.variants.find((v) => v.available) || p.variants[0]);
    open(modal);
  }
  modal.addEventListener("click", (e) => {
    const t = e.target.closest("[data-src]"); if (t) setMainImage(t.dataset.src);
    const v = e.target.closest("[data-vid]"); if (v) selectVariant(current.variants.find((x) => x.id === Number(v.dataset.vid)));
    const q = e.target.closest("[data-q]");
    if (q) { qty = Math.max(1, Math.min(20, qty + Number(q.dataset.q))); $("pm-qty").textContent = qty; }
  });
  $("pm-add").addEventListener("click", async () => {
    if (!variant || !variant.available) return;
    const btn = $("pm-add");
    btn.disabled = true; btn.textContent = "Adding…";
    try {
      await addToCart(variant.id, qty);
      MU.toast && MU.toast(`Added ${current.title} to cart`);
    } catch (err) {
      MU.toast && MU.toast(err.message);
      open(modal);
    } finally {
      btn.disabled = !variant.available; btn.textContent = variant.available ? "Add to Cart" : "Sold Out";
    }
  });

  document.addEventListener("click", async (e) => {
    const card = e.target.closest("[data-quick-view]");
    if (!card || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
    e.preventDefault();
    const handle = card.dataset.handle;
    try {
      if (!cache[handle]) {
        const r = await fetch(`${R.root}products/${handle}.js`.replace("//products", "/products"));
        if (!r.ok) throw new Error();
        cache[handle] = await r.json();
      }
      openProduct(cache[handle]);
    } catch {
      window.location.href = card.href;
    }
  });

  /* ---------- Product page form ---------- */
  document.querySelectorAll("form[data-product-form]").forEach((form) => {
    const data = form.querySelector("[data-variants]");
    const variants = data ? JSON.parse(data.textContent) : [];
    const idInput = form.querySelector('input[name="id"]');
    const priceEl = document.querySelector("[data-pdp-price]");
    const mainImg = document.querySelector("[data-pdp-img]");
    const nameEl = form.querySelector("[data-pdp-vname]");
    const btn = form.querySelector('button[type="submit"]');
    const setVariant = (v) => {
      idInput.value = v.id;
      form.querySelectorAll("[data-vid]").forEach((b) => b.setAttribute("aria-pressed", String(Number(b.dataset.vid) === v.id)));
      if (nameEl) nameEl.textContent = v.title;
      if (priceEl) priceEl.innerHTML = priceHTML(v);
      if (mainImg && v.featured_image) mainImg.src = sized(v.featured_image.src, 1200);
      btn.disabled = !v.available;
      btn.textContent = v.available ? "Add to Cart" : "Sold Out";
      const url = new URL(window.location.href);
      url.searchParams.set("variant", v.id);
      history.replaceState(null, "", url);
    };
    form.addEventListener("click", (e) => {
      const b = e.target.closest("[data-vid]");
      if (b) { e.preventDefault(); setVariant(variants.find((v) => v.id === Number(b.dataset.vid))); }
      const q = e.target.closest("[data-q]");
      if (q) {
        e.preventDefault();
        const input = form.querySelector('input[name="quantity"]');
        input.value = Math.max(1, Math.min(20, Number(input.value) + Number(q.dataset.q)));
        form.querySelector("[data-qty-label]").textContent = input.value;
      }
    });
    form.addEventListener("submit", async (e) => {
      e.preventDefault();
      btn.disabled = true; btn.textContent = "Adding…";
      try {
        await addToCart(Number(idInput.value), Number(form.querySelector('input[name="quantity"]').value || 1));
        MU.toast && MU.toast("Added to cart");
      } catch (err) {
        MU.toast && MU.toast(err.message);
      } finally {
        const v = variants.find((x) => x.id === Number(idInput.value));
        btn.disabled = v ? !v.available : false;
        btn.textContent = !v || v.available ? "Add to Cart" : "Sold Out";
      }
    });
  });
  document.querySelectorAll("[data-pdp-thumb]").forEach((b) => b.addEventListener("click", () => {
    const img = document.querySelector("[data-pdp-img]");
    if (img) img.src = b.dataset.src;
    document.querySelectorAll("[data-pdp-thumb]").forEach((x) => x.setAttribute("aria-current", String(x === b)));
  }));
})();
